import React, { FC, useEffect, useRef, useState } from 'react'
import { Modal, Row, Table, Input, Col, Tabs, Timeline, Button, message } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { useAssetsInventoryDetailsModel } from './assetsInventoryDetailsModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { assetsInventoryService } from '../../assetsInventoryService'
import { ISCMAssetsInventoryDetail } from '../../assetsInventoryTypes'
import { ISearchPage } from '@/types/AppTypes'
import useNavModel, { ModeType } from '@/model/navModel'
import { useDictModel } from '@/views/base/dict/dictModel'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { YhFormBox } from '@/components/YhFormBox'
import { ClockCircleOutlined, SmileOutlined, SyncOutlined } from '@ant-design/icons'
import { spawn } from 'child_process'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { formatNum } from '@/utils/utils'
import { globalPrompt } from '@/components/message'
import { useAssetsInventoryModel } from '../../assetsInventoryModel'
import YhTootip from '@/components/YhTootip'


export const MaterialCodeModal = () => {
    const { loadData } = useAssetsInventoryModel()
    const { warehouseList } = useGlobalModel();
    const { materialCodeVisible: visible, setMaterialCodeVisible,editGoodsList, setEditGoodsList,editFormVal,updateSDc,onComplete,onFinalAudit } = useAssetsInventoryDetailsModel()
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: DEFAULT_FIRST_PAGE_NUM }
    const { getSelectedDictOne,getTreeSelectOne,getTreeNodeName } = useDictModel(() => []);
    const [newMaterialList, setNewMaterialList] = useState<any>([]);
    //tabs分类详情
    const [tabsActiveDetails, setTabsactiveDetails] = useState<'All'|string>('All')
    const [selectKeys, setSelectKeys] = useState<string[]>([])
    const [selectedRows, setSelectedRows] = useState<any>([]);
    const formRef = useRef<IYhFormRef>()
    const { selectedNavId, replaceNav, findNav } = useNavModel()
    useEffect(() => {
        setTabsactiveDetails('All')
        setNewMaterialList(editGoodsList.filter((item)=>item.result!=='相符'))
        setSelectKeys([])
        setSelectedRows([])
    }, [visible])

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 50,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '物资编码',
            width: 160,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '物资名称',
            width: 140,
            dataIndex: 'materialName',
            fixed: "left",
        }, {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? ''

        }, {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) =><YhTootip text={text} />,
        },  {
            title: '单位',
            width: 80,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',  
        },  {
            title: '单价',
            width: 80,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`
        }, 
        {
            title: '库存数量',
            width: 100,
            dataIndex: 'inventoryNum',
        },{
            title: '盘点数量',
            width: 100,
            dataIndex: 'realNum',
        },{
            title: '差异数量',
            width: 100,
            dataIndex: 'differenceNum',
        }, {
            title: '差异金额',
            width: 100,
            dataIndex: 'differenceAmount',
            render: (text: any) => `￥${text ? Number(text).toFixed(2) : "0.00"}`
        },
        {
            title: '盘点结果',
            width: 100,
            dataIndex: 'result',
        },
        {
            title: '领用人',
            width: 100,
            dataIndex: 'user',
        },
        {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseCode',
            render: (text: string) =>warehouseList.find((item) => item.value === text)?.label ?? '请选择仓库',
        },
        {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
        },{
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },{
            title: '存放地点',
            width: 130,
            dataIndex: 'deposit',
        },{
            title: '盘点类型',
            width: 110,
            dataIndex: 'type',
            fixed: "right",
            render: (text: string) =>getSelectedDictOne(DictCodeEnmu.ASSETS_TRANSFER_TYPE).find((item) => item.value === text)?.label ?? '请选择',
        }
    ];


    const flowRecordLoadData = async (value) => {
        if(value=='All'){
            setNewMaterialList(editGoodsList.filter((item)=>item.result!=='相符'))
        }else{
        setNewMaterialList(editGoodsList.filter((item)=>item.type==value&&item.result!=='相符'))
    }}
    const onOk = async () => {
        if(editFormVal.status== DictCodeEnmu.ASSETS_STOCKTAKING_CREATE){
        let waringData=editGoodsList.filter((item)=>!item.type&&item.result!=='相符')
        if(waringData.length>0){
            message.warning('请补全所有盘点类型后提交！')
        }else{
            updateSDc({...editFormVal,id:editFormVal.id}).then(async (res) => {
                if (res) {
                    let { stocktakingCode, id, } = editFormVal
                    let retData = await onComplete({ stocktakingCode, id })
                    if(retData){
                        message.success("盘点成功")
                        setMaterialCodeVisible(false)
                        replaceNav(selectedNavId, '3-1')
                        loadData(initPgCfg, {});
                    }else {
                        message.error("盘点失败")
                    }
                }
            })
        }}
        else if(editFormVal.status== DictCodeEnmu.ASSETS_STOCKTAKING_COMPLETE){
            let { stocktakingCode, id, status } = editFormVal
            let retData = await onFinalAudit({ stocktakingCode, id })
            if(retData){
                message.success("审核成功")
                setMaterialCodeVisible(false)
                replaceNav(selectedNavId, '3-1')
                loadData(initPgCfg, {});
            }else {
                message.error("审核失败")
            }
        }
    }
    const onTypeChange = (value) => {
        if (!selectKeys.length) {
            globalPrompt('message', { text: '请选择数据进行状态更改', type: 'warning' })
            return
        }
        setEditGoodsList(editGoodsList.map((list:any)=>{
            if(selectKeys.includes(list.id)){
                return{...list,type:value}
        }else{
            return list
        }
           }))
        setTabsactiveDetails('All')
        setNewMaterialList(editGoodsList.filter((item)=>item.result!=='相符').map((list:any)=>{
            if(selectKeys.includes(list.id)){
                return{...list,type:value}
        }else{
            return list
        }
           }))
    }
     //点击行选高亮
     const onRow = (key: any) => {
        let findIndex = selectKeys.indexOf(key.id);
        let newSelectedRowKeys = [...selectKeys];
        let newSelectedRows = [...selectedRows];
        if (findIndex === -1) {
            newSelectedRowKeys.push(key.id);
            newSelectedRows.push(key);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            newSelectedRows.splice(findIndex, 1);
        }
        setSelectKeys(newSelectedRowKeys)
        setSelectedRows(newSelectedRows)
    };
    return (
        <Modal
            visible={visible}
            // title="选择商品"
            onCancel={() => {
                setMaterialCodeVisible(false)
            }}
            onOk={onOk}
            width={1200}
        >
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
            <Tabs
                defaultActiveKey={tabsActiveDetails}
                type="card"
                onChange={(e) => {
                    setTabsactiveDetails(e)
                    flowRecordLoadData(e)
                    setSelectKeys([])
                    setSelectedRows([])
                }}
            >
                <Tabs.TabPane tab="全部差异" key="All"/>
            {(getSelectedDictOne(DictCodeEnmu.ASSETS_TRANSFER_TYPE)).map((item:any) => {
            if(item.value!=='assets-transfer-type.discard'){
               return <Tabs.TabPane tab={item.label} key={item.value}/>
            }}
            )}
            </Tabs>
            {editFormVal.status== DictCodeEnmu.ASSETS_STOCKTAKING_CREATE&&<div style={{margin:'5px 50px 0 0'}}>
                <Button type="link" onClick={()=>onTypeChange('assets-transfer-type.loss')} disabled={selectedRows.filter((item)=>item.result=='盘盈').length>0}>损失</Button>
                {/* <Button type="link" onClick={()=>onTypeChange('assets-transfer-type.discard')}  disabled={selectedRows.filter((item)=>item.result=='盘盈').length>0}>报废</Button> */}
                <Button type="link" onClick={()=>onTypeChange('assets-transfer-type.purchase')}  disabled={selectedRows.filter((item)=>item.result=='盘亏').length>0}>新增</Button>
            </div>}
            </div>
            <Table
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={newMaterialList}
                scroll={{ x: 'max-content',y:530}}
                rowSelection={{
                    //全部选中时  (存string[])
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        let changeRowId = changeRows.map((item) => item.id)
                        if (selected) {
                            setSelectKeys([...selectKeys, ...changeRowId])
                            setSelectedRows(selectedRows)
                        } else {
                            setSelectKeys(selectKeys.filter((item) => changeRowId.indexOf(item) < 0))
                            setSelectedRows([])
                        }
                    },
                    onSelect: (record) => onRow(record),
                    selectedRowKeys: selectKeys,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => onRow(record),
                })}
            />
        </Modal>
    )
}
